/** Mirrors backend/lib/schoolVerification.js */

export function normalizeVerificationStatus(value) {
    const status = String(value ?? "").trim().toLowerCase();
    if (status === "pending" || status === "rejected") return status;
    return "approved";
}

/** Resolve approval from verification fields, subscription state, and legacy schools. */
export function resolveSchoolVerificationStatus(admin) {
    if (!admin || typeof admin !== "object") {
        return normalizeVerificationStatus(admin);
    }

    const explicit = normalizeVerificationStatus(admin.verificationStatus);
    if (explicit === "rejected") return "rejected";

    const subscriptionStatus = String(admin.subscriptionStatus || "").trim().toLowerCase();
    const awaitingReview = Boolean(admin.verificationRequestedAt) && !admin.verificationReviewedAt;

    if (
        explicit === "pending" ||
        subscriptionStatus === "pending_verification" ||
        awaitingReview
    ) {
        return "pending";
    }

    return "approved";
}

export function isSchoolVerificationApproved(admin) {
    return resolveSchoolVerificationStatus(admin) === "approved";
}
